import { render, staticRenderFns } from "./FichaTecnicaWorkflowPage.vue?vue&type=template&id=20070c29"
import script from "./FichaTecnicaWorkflowPage.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaWorkflowPage.vue?vue&type=script&lang=js"
import style0 from "./FichaTecnicaWorkflowPage.vue?vue&type=style&index=0&id=20070c29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports